import StatusIcon from "./StatusIcon";
import Loading from "../components/Loading";

function formatDate(dateString) {
  const dateObj = new Date(dateString);
  const mm = dateObj.getMonth() + 1;
  const dd = dateObj.getDate();
  return [
    (dd > 9 ? "" : "0") + dd,
    (mm > 9 ? "" : "0") + mm,
    dateObj.getFullYear(),
  ].join("-");
}

function Table({
  columns = [],
  rows = [],
  filterStat,
  colour = "#c5cdfb",
  loading = false,
}) {
  const filteredRows = filterStat
    ? rows.filter((row) => row.status === filterStat)
    : rows;

  return (
    <div className="table-container w-full bg-white text-[#585858] rounded-2xl outline-2 outline-gray-200 overflow-hidden">
      {/* Header */}
      <div
        className="grid font-semibold py-[0.5rem] px-[1rem] border-b-2 border-gray-200"
        style={{
          gridTemplateColumns: `repeat(${columns.length}, 1fr)`,
          backgroundColor: colour,
        }}
      >
        {columns.map((col, idx) => (
          <div
            key={idx}
            className={`${
              col.align === "center" ? "text-center" : "text-left"
            }`}
          >
            {col.label}
          </div>
        ))}
      </div>

      {/* Loader or Rows */}
      {loading ? (
        <Loading />
      ) : (
        <div>
          {filteredRows.length > 0 ? (
            filteredRows.map((row, rowIndex) => (
              <div
                key={rowIndex}
                className={`grid px-[1rem] items-center ${
                  rowIndex !== filteredRows.length - 1
                    ? "border-b-2 border-gray-200"
                    : ""
                }`}
                style={{
                  gridTemplateColumns: `repeat(${columns.length}, 1fr)`,
                }}
              >
                {columns.map((col, colIndex) => {
                  const cellData = row[col.key];
                  let displayValue = cellData;

                  if (col.render) {
                    displayValue = col.render(row);
                  } else if (col.format === "date") {
                    displayValue = formatDate(cellData);
                  } else if (col.format === "status") {
                    displayValue = <StatusIcon status={cellData} />;
                  } else if (
                    col.format === "arrayValue" &&
                    Array.isArray(cellData)
                  ) {
                    displayValue = cellData[0]?.value || "-";
                  } else if (
                    col.format === "objectValue" &&
                    typeof cellData === "object"
                  ) {
                    displayValue = cellData?.value || "-";
                  } else if (
                    typeof displayValue === "object" &&
                    displayValue !== null
                  ) {
                    displayValue = "-";
                  }

                  return (
                    <div
                      key={colIndex}
                      className={`overflow-x-hidden text-md py-[1rem] ${
                        col.align === "center" ? "text-center" : "text-left"
                      } ${col.className}`}
                    >
                      {displayValue}
                    </div>
                  );
                })}
              </div>
            ))
          ) : (
            <div className="text-center py-6 text-gray-400">
              No data available.
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Table;
